export const INITIAL_AND_REVIEW_APT_LENGTH_LIST = [
  {
    value: "15-15",
    label: "15mins and 15mins",
  },
  {
    value: "20-10",
    label: "20mins and 10mins",
  },
  {
    value: "30-15",
    label: "30mins and 15mins",
  },
  {
    value: "30-20",
    label: "30mins and 20mins",
  },
  {
    value: "30-30",
    label: "30mins and 30mins",
  },
  {
    value: "40-20",
    label: "40mins and 20mins",
  },
  {
    value: "45-15",
    label: "45mins and 15mins",
  },
  {
    value: "45-20",
    label: "45mins and 20mins",
  },
  {
    value: "45-30",
    label: "45mins and 30mins",
  },
  {
    value: "60-20",
    label: "60mins and 20mins",
  },
  {
    value: "60-30",
    label: "60mins and 30mins",
  },
  {
    value: "60-60",
    label: "60mins and 60mins",
  },
  {
    value: "90-45",
    label: "90mins and 45mins",
  },
  {
    value: "120-45",
    label: "120mins and 45mins",
  },
];

export const TIMEZONE_LIST = [
  { value: "-12:00", label: "(GMT -12:00) Eniwetok, Kwajalein" },
  { value: "-11:00", label: "(GMT -11:00) Midway Island, Samoa" },
  { value: "-10:00", label: "(GMT -10:00) Hawaii" },
  { value: "-09:50", label: "(GMT -9:30) Taiohae" },
  { value: "-09:00", label: "(GMT -9:00) Alaska" },
  {
    value: "-08:00",
    label: "(GMT -8:00) Pacific Time (US &amp; Canada)",
  },
  {
    value: "-07:00",
    label: "(GMT -7:00) Mountain Time (US &amp; Canada)",
  },
  {
    value: "-06:00",
    label: "(GMT -6:00) Central Time (US &amp; Canada), Mexico City",
  },
  {
    value: "-05:00",
    label: "(GMT -5:00) Eastern Time (US &amp; Canada), Bogota, Lima",
  },
  { value: "-04:50", label: "(GMT -4:30) Caracas" },
  {
    value: "-04:00",
    label: "(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz",
  },
  { value: "-03:50", label: "(GMT -3:30) Newfoundland" },
  {
    value: "-03:00",
    label: "(GMT -3:00) Brazil, Buenos Aires, Georgetown",
  },
  { value: "-02:00", label: "(GMT -2:00) Mid-Atlantic" },
  { value: "-01:00", label: "(GMT -1:00) Azores, Cape Verde Islands" },
  {
    value: "+00:00",
    label: "(GMT) Western Europe Time, London, Lisbon, Casablanca",
  },
  {
    value: "+01:00",
    label: "(GMT +1:00) Brussels, Copenhagen, Madrid, Paris",
  },
  { value: "+02:00", label: "(GMT +2:00) Kaliningrad, South Africa" },
  {
    value: "+03:00",
    label: "(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg",
  },
  { value: "+03:50", label: "(GMT +3:30) Tehran" },
  {
    value: "+04:00",
    label: "(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi",
  },
  { value: "+04:50", label: "(GMT +4:30) Kabul" },
  {
    value: "+05:00",
    label: "(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent",
  },
  {
    value: "+05:50",
    label: "(GMT +5:30) Bombay, Calcutta, Madras, New Delhi",
  },
  { value: "+05:75", label: "(GMT +5:45) Kathmandu, Pokhara" },
  { value: "+06:00", label: "(GMT +6:00) Almaty, Dhaka, Colombo" },
  { value: "+06:50", label: "(GMT +6:30) Yangon, Mandalay" },
  { value: "+07:00", label: "(GMT +7:00) Bangkok, Hanoi, Jakarta" },
  {
    value: "+08:00",
    label: "(GMT +8:00) Beijing, Perth, Singapore, Hong Kong",
  },
  { value: "+08:75", label: "(GMT +8:45) Eucla" },
  {
    value: "+09:00",
    label: "(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk",
  },
  { value: "+09:50", label: "(GMT +9:30) Adelaide, Darwin" },
  {
    value: "+10:00",
    label: "(GMT +10:00) Eastern Australia, Guam, Vladivostok",
  },
  { value: "+10:50", label: "(GMT +10:30) Lord Howe Island" },
  {
    value: "+11:00",
    label: "(GMT +11:00) Magadan, Solomon Islands, New Caledonia",
  },
  { value: "+11:50", label: "(GMT +11:30) Norfolk Island" },
  {
    value: "+12:00",
    label: "(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka",
  },
  { value: "+12:75", label: "(GMT +12:45) Chatham Islands" },
  { value: "+13:00", label: "(GMT +13:00) Apia, Nukualofa" },
  { value: "+14:00", label: "(GMT +14:00) Line Islands, Tokelau" },
];

export const TIMEZONE = [
  "Australia/Perth",
  "Australia/Eucla",
  "Australia/Adelaide",
  "Australia/Broken_Hill",
  "Australia/Darwin",
  "Australia/Brisbane",
  "Australia/Currie",
  "Australia/Hobart",
  "Australia/Lindeman",
  "Australia/Melbourne",
  "Australia/Sydney",
  "Australia/Lord_Howe",
  "Antarctica/Macquarie",
];
